const B2BIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_15964_89351)">
      <path
        d="M19.8438 11.125H12.1562C10.6227 11.125 9.375 12.3726 9.375 13.9062C9.375 15.4399 10.6226 16.6875 12.1562 16.6875H19.8438C21.3773 16.6875 22.625 15.4399 22.625 13.9062C22.625 12.3726 21.3773 11.125 19.8438 11.125ZM13.3022 14.2499C13.3022 14.7677 12.8825 15.1874 12.3647 15.1874C11.847 15.1874 11.4272 14.7677 11.4272 14.2499V13.5624C11.4272 13.0447 11.847 12.6249 12.3647 12.6249C12.8825 12.6249 13.3022 13.0447 13.3022 13.5624V14.2499ZM20.5727 14.2499C20.5727 14.7677 20.1529 15.1874 19.6352 15.1874C19.1174 15.1874 18.6977 14.7677 18.6977 14.2499V13.5624C18.6977 13.0447 19.1174 12.6249 19.6352 12.6249C20.1529 12.6249 20.5727 13.0447 20.5727 13.5624V14.2499Z"
        fill="white"
      />
      <path
        d="M27.3125 16.1248V14.3127C27.3125 8.0455 22.2345 3.125 16 3.125C9.75881 3.125 4.6875 8.04625 4.6875 14.3127V16.1248C4.6875 19.0165 7.04631 21.375 9.93769 21.375H22.0623C24.9537 21.375 27.3125 19.0162 27.3125 16.1248ZM12.1562 18.5624C9.58881 18.5624 7.5 16.4737 7.5 13.9062C7.5 11.3387 9.58875 9.24994 12.1562 9.24994H19.8438C22.4112 9.24994 24.5 11.3387 24.5 13.9062C24.5 16.4737 22.4112 18.5624 19.8438 18.5624H12.1562Z"
        fill="white"
      />
      <path
        d="M20.875 25.125H18.8125C17.7812 25.125 16.9375 25.9688 16.9375 27C16.9375 28.0312 17.7812 28.875 18.8125 28.875H20.875C21.9062 28.875 22.75 28.0312 22.75 27C22.75 25.9688 21.9062 25.125 20.875 25.125Z"
        fill="white"
      />
      <path
        d="M30.1286 22.281C30.1286 24.3647 28.3251 26.125 26.1903 26.125H24.5245C24.5919 26.4059 24.6286 26.6987 24.6286 27C24.6286 27.3463 24.5804 27.6814 24.4922 28H26.1903C29.3414 28 32.0036 25.381 32.0036 22.281V20.4487C31.4583 20.859 30.821 21.1534 30.1286 21.2945V22.281Z"
        fill="white"
      />
      <path
        d="M29.1905 10.0763H29.1094V4.65478C29.1094 4.13703 28.6896 3.71729 28.1719 3.71729C27.6541 3.71729 27.2344 4.13703 27.2344 4.65478V7.42653C28.5084 9.46729 29.1905 11.8327 29.1905 14.3127V16.1248C29.1905 17.3507 28.8793 18.5053 28.3316 19.5138H29.1905C30.7413 19.5138 32.003 18.2521 32.003 16.7013V12.8888C32.003 11.338 30.7413 10.0763 29.1905 10.0763Z"
        fill="white"
      />
      <path
        d="M2.8125 14.3127C2.8125 11.8316 3.49456 9.46541 4.76856 7.42441V4.65478C4.76856 4.13703 4.34881 3.71729 3.83106 3.71729C3.31331 3.71729 2.89356 4.13703 2.89356 4.65478V10.0763H2.8125C1.26169 10.0763 0 11.338 0 12.8888V16.7013C0 18.2521 1.26169 19.5138 2.8125 19.5138H3.67138C3.12375 18.5053 2.8125 17.3508 2.8125 16.1248V14.3127Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_15964_89351">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default B2BIcon
